export {
  emailErrors,
  passwordErrors,
  confirmPasswordErrors,
  lengthError
}

function emailErrors ($v) {
  const errors = []
  if (!$v.email.$dirty) return errors
  !$v.email.email && errors.push('Must be valid e-mail')
  !$v.email.required && errors.push('E-mail is required')
  return errors
}

function passwordErrors ($v) {
  const errors = []
  if (!$v.password.$dirty) return errors
  !$v.password.required && errors.push('Password is required')
  !$v.password.minLength && errors.push(`Password must have more than 6 characters`)
  !$v.password.maxLength && errors.push(`Password must have less than 20 characters`)
  return errors
}
// ${$v.password.$params.between.min}-${$v.password.$params.between.max}
function confirmPasswordErrors ($v) {
  const errors = []
  if (!$v.confirmPassword.$dirty) return errors
  !$v.confirmPassword.required && errors.push('Password confirmation is required')
  !$v.confirmPassword.minLength && errors.push(`Password must have more than 6 characters`)
  !$v.confirmPassword.maxLength && errors.push(`Password must have less than 20 characters`)
  !$v.confirmPassword.sameAs && errors.push('Passwords must match')
  return errors
}

function lengthError (validation) {
  return (validation) ? 'Must have more than 4 characters' : null
}
